import React from "react";
import { logoutSession } from '../../utils/login';
import { getTokens } from '../../utils/loginSession';
import base64 from 'base-64';
import { isTokenValid } from '../../utils/helper';

function Landing() {
  const redirect = true;
  let currentPath = "";
  if (window.location.hostname !== 'localhost' && window.location.hostname !== '172.0.0.1')
    currentPath = window.location.hostname;

  let loginUrl = "";
  let redirectUri = "";
  let cancelRedirect = "";
  let clientId = "";
  let clientApp = "";

  if (currentPath === 'uat.biz.amway.com.ph' || currentPath === 'biz.amway.com.ph') {
    redirectUri = process.env.REACT_APP_LOGIN_ENV === "uat" ? "https://uat.biz.amway.com.ph/oauth/authorize" : "https://biz.amway.com.ph/oauth/authorize";
    cancelRedirect = process.env.REACT_APP_LOGIN_ENV === "uat" ? "https://uat1.amway.com.ph" : "https://amway.com.ph";
    clientId = process.env.REACT_APP_LOGIN_ENV === "uat" ? "4be298b8-fcb8-450f-8606-3a5aa7d0eff1" : "e304ac65-7a12-4575-9482-8d0699a8bf22";
    clientApp = "BusinessDashboardPHL";
  } else if (currentPath === 'psup.biz.amway.com.ph') {
    redirectUri = `https://psup.biz.amway.com.ph/oauth/authorize`;
    cancelRedirect = "https://psup1.amway.com.ph"; // TODO: change this
    clientId ="609020f3-2b62-4c41-9cff-1359c04ae48f";
    clientApp = "BusinessDashboardPHL";
  }

  // const amwayIdDomain = process.env.REACT_APP_LOGIN_ENV === "prod" ? "https://account.amwayglobal.com" : "https://account-apacreg-qa.amwayglobal.com";
  //gluu
  let amwayIdDomain
  if(process.env.REACT_APP_LOGIN_ENV == "prod"){
    amwayIdDomain = "https://account2.amwayglobal.com/v1/proxy/oxauth/rest"
  }else if(process.env.REACT_APP_LOGIN_ENV == "uat"){
    amwayIdDomain = "https://account-apacreg-qa2.amwayglobal.com/v1/proxy/oxauth/rest"
  }else if(process.env.REACT_APP_LOGIN_ENV == "psup"){
    amwayIdDomain = "https://account-perf2.amwayglobal.com/v1/proxy/oxauth/rest"
  }
    
  // const serverId = process.env.REACT_APP_LOGIN_ENV === "prod" ? "ausbw9tp2iqCJklAw1t7" : "ausnmpoj9bWKNVHVk0h7";
  const nonce = "1qazxsw23edcvfr4";
  const locale = "en-us";
  let state = {
    amw_lng: locale,
    amw_clientapp: clientApp,
  };
  state = base64.encode(state);

  // loginUrl = `${amwayIdDomain}/v1/proxy/oauth2/${serverId}/v1/authorize?response_mode=form_post&response_type=id_token code token&scope=openid profile abo abo_name accounts_details_profile offline_access account_profile bonus:all:read mdms:accounts:read&nonce=${nonce}&state=${state}&redirect_uri=${redirectUri}&cancelredirect=${cancelRedirect}&client_id=${clientId}&amw_clientapp=${clientApp}&amw_lng=${locale}`;
  //gluu
  loginUrl = `${amwayIdDomain}v1/authorize?response_mode=form_post&response_type=id_token code token&scope=openid profile abo abo_name accounts_details_profile offline_access account_profile bonus:all:read mdms:accounts:read&nonce=${nonce}&state=${state}&redirect_uri=${redirectUri}&cancelredirect=${cancelRedirect}&client_id=${clientId}&amw_clientapp=${clientApp}&amw_lng=${locale}`;

  const checkRedirect = () => {
    if (typeof window !== 'undefined') {
      const atoken = getTokens().accessToken;
      const isExpired = !isTokenValid(atoken);

      if (atoken && typeof atoken !== 'undefined' && atoken !== 'undefined' && atoken !== '' && !isExpired) {
        console.log("Landing: logon user, redirect to home page");
        if (redirect)
          window.location.href = '/home';
      } else {
        logoutSession();
        console.log("Landing: redirect to login page");
        if (redirect) {
          if (process.env.REACT_APP_LOGIN_ENV === "dev" || (process.env.REACT_APP_LOGIN_ENV === "uat" && currentPath === "") || (process.env.REACT_APP_LOGIN_ENV === "prod" && currentPath === "")) {
            window.location.href = '/testPost';
          } else if (process.env.REACT_APP_LOGIN_ENV === "uat") {
            window.location.href = loginUrl;
          } else if (process.env.REACT_APP_LOGIN_ENV === "prod") {
            window.location.href = loginUrl;
          } else if (process.env.REACT_APP_LOGIN_ENV === "psup") {
            window.location.href = loginUrl;
          }
        }
      }

    }
  }

  setTimeout(checkRedirect, 0)

  return (
    <></>
  );
}

export default Landing;
